const compareNumbers = (num1, num2) => {
  if (num1 > num2) {
    return true;
  } else if (num2 > num1) {
    return false;
  } else {
    return null;
  }
};

/**
 * Compares version1 and version2. Returns true is version1 is greater than version2,
 * false if version2 is greter than version 1 and null if versions are equal
 *
 * @param {number[]} version1   version1 as a list of version numbers
 * @param {number[]} version2   version2 as a list of version numbers
 * @returns {boolean}           true is version1 is greater than version2,
 *                              false if version2 is greter than version 1,
 *                              null if versions are equal
 */
const compareVersions = (version1 = [], version2 = []) => {
  for (let i = 0; i < version2.length; i++) {
    const res = compareNumbers(parseInt(version1[i]), parseInt(version2[i]));

    if (res !== null) {
      return res;
    }
  }

  return null;
};

export const versionUtils = {
  compareVersions
};
